import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
   CardBody, CardTitle, CardText,
   Button, } from "reactstrap";
import logo from "../assets/carousel.png";
import logo1 from "../assets/HKCL_Logo.png";
import logo2 from "../assets/pic1.png";
import Aos from "aos";
import { Nav, NavItem, NavLink, TabContent, TabPane, } from 'reactstrap';
import { FaChevronRight,} from "react-icons/fa";

import { useNavigate } from "react-router-dom";
import price from '../assets/price.png'
const Home = () => {
  const navigate = useNavigate();
  const [activePriceTab, setActivePriceTab] = useState("award");
  useEffect(() => {
    Aos.init({ duration: 2000 }); 
    window.scrollTo(0,0);
  }, []);
  const [open, setOpen] = useState("");

  const toggle = (id) => {
    setOpen(open === id ? "" : id); 
  };
  const [activeTab, setActiveTab] = useState('1');

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const plans = [
    { duration: "1 Month Plan", price: "Rs. 499/-" },
    { duration: "3 Months Plan", price: "Rs. 1399/-" },
    { duration: "6 Months Plan", price: "Rs. 2599/-" },
    { duration: "1 Year Plan", price: "Rs. 4999/-" },
  ];

  const faqDatastudent = [
    {
      id: "1",
      question: "Why should I buy the HKCL AI Application? ",
      answer:
        "The HKCL AI Application offers 15 AI-driven interview simulations, 50 live soft skill courses led by experts, and actionable feedback to boost confidence and employability. It bridges skill gaps, enhances professional growth, and prepares you for real-world challenges—all at an affordable price. Unlock your potential with HKCL AI Application! ",
    },
    {
      id: "2",
      question: "How can I select the right program for myself? ",
      answer:
        "The form provides a dropdown or radio buttons with available program options to select plan of either 1 Month/ 3 Months/ 6 Months or of 1 Year. Choose the program that best suits your learning goals",
    },
    {
      id: "3",
      question: "Is the fee refundable? ",
      answer: "No, the fee is non-refundable under any circumstances. ",
    },
    {
      id: "4",
      question: "Can I change my program duration after registration? ",
      answer:
        "No, once the registration and payment are completed, the selected program duration cannot be changed. You can purchase another plan in addition to the existing. ",
    },
    {
      id: "5",
      question: "What payment methods are available? ",
      answer:
        "You can pay using Credit/Debit Card, Net Banking, UPI, or other supported payment methods.",
    },
    {
      id: "6",
      question: "Will I receive a confirmation after registration?",
      answer:
        "Yes, once your payment is successfully processed, you will receive a confirmation email and SMS with details of your enrollment. ",
    },
    {
      id: "7",
      question: "What should I do if I don’t receive the OTP for verification? ",
      answer:
        "If you do not receive the confirmation mail/message, ensure you have entered your mobile number and email address correctly or check spam folder. If the issue persists, contact HKCL support for assistance at 0172-5210290 or email the support team at info@hkcl.in. ",
    },
    {
      id: "8",
      question: "How can I access the program after registration? ",
      answer:
        "You’ll receive all the details to access the program on your given mail id. ",
    },
    
  ];
  const faqDataalc = [
    {
      id: "1",
      question: "Why should we join the HKCL AI Application?  ",
      answer:
        "As an Authorized Learning Center (ALC) of HKCL, joining the HKCL Application allows you to enhance your business offerings by providing cutting-edge AI-based interview preparation tools and soft skill courses to your students. This partnership gives you access to a high-demand, value-driven service that attracts more students and boosts your credibility in the competitive education market. Expand your educational services and create new revenue streams with NayiDisha!  ",
    },
    {
      id: "2",
      question: "What is the ALC Code, and why is it required?  ",
      answer:
        "The ALC Code is a unique identifier for each Authorized Learning Center given by HKCL. It is required to verify your identity and create a login for accessing the portal and for the enrollment of the students. ",
    },
    {
      id: "3",
      question: "Can I register multiple students at once? ",
      answer: "Yes, you can add multiple students individually through the form available in your login or use the bulk upload option (via CSV or Excel file) for registering the large number of students at once.  ",
    },
    {
      id: "4",
      question: "How do I make a payment for multiple students?   ",
      answer:
        "Once all the students are registered, you can select them for payment on the portal. The total fee will be auto calculated, and you can make a single payment for all students.  ",
    },
    {
      id: "5",
      question: "What payment methods are available?  ",
      answer:
        "You can pay using Credit/Debit Card, Net Banking, UPI, or other supported payment methods.",
    },
    {
      id: "6",
      question: "What should I do if a student’s details are entered incorrectly? ",
      answer:
        "If any student’s details are entered incorrectly, it may require HKCL’s approval. ",
    },
    {
      id: "7",
      question: "Can I access reports of registered students?  ",
      answer:
        "Yes, the portal provides a dashboard where you can view the details of all registered students.",
    },
    {
      id: "8",
      question: "Can I change the email ID or mobile number linked to my ALC?  ",
      answer:
        "No, the email ID and mobile number linked to your ALC account are as per the HKCL records. Contact HKCL office for changes if required.  ",
    },
    {
      id: "9",
      question: " Will I receive a confirmation after registration? ",
      answer:
        "Yes, once your payment is successfully processed, you will receive a confirmation email and SMS with details of your enrollment on your registered email id and mobile number. ",
    },
    {
      id: "10",
      question: "How the students enrolled by my ALC can access the program after registration & successful payment?  ",
      answer:
        "The students will receive all the details to access the program on the student’s given mail id and mobile number.   ",
    },
    
  ];

  return (
    <>
      <div className="apply-now-button" onClick={() => navigate("/register")}>
        <i className="bi bi-hand-index-thumb"></i>
        <span>Enroll Now</span>
      </div>
      <section id="home" className="home-section">
        <Container className="py-3" data-aos="fade-up">
          <img className="mb-2" src={logo} width={"100%"} data-aos="fade-up"/>
         
          <Row>
            
            <Col md={12} xs={12}  data-aos="fade-up">
              <div className="py-4 text-justify">
                <h1 className="text-center">HKCL AI Application-Mentza</h1>
                <p style={{"font-family": "Rubik", fontSize:"24px",textAlign:"justify"}}>
                  A platform aims to provide cutting-edge tools for AI-based interview simulations, soft skill assessments, and access to live soft skill courses led by
                  professional coaches, designed to facilitate registrations from students, schools,
                  colleges, universities, and authorized learning centres
                  associated with HKCL. This innovative portal is dedicated to
                  empowering individuals with state-of-the-art tools for
                  professional development, including AI-driven interview
                  simulations, comprehensive soft skill assessments, and live
                  courses led by seasoned industry experts.
                </p>
                
              </div>
            </Col>
            <img className="mb-2" src={logo2} width={"100%"} data-aos="fade-up"/>
            <Col md={12} xs={12} >
              <div className="pt-4 text-justify" data-aos="fade-up">
            <h3 className="mb-4 text-center">Objectives of HKCL AI Application</h3>

            <Row className="justify-content-center ">
        
          <Col md="4"  className="mb-3 align-middle" data-aos="fade-up">
           <Card className="shadow-sm text-center pb-1 custom-card" >
           <div style={{height:"5px",background:"#4FACFE"}}></div>
              <CardBody>
               
                <CardTitle tag="h5" className=" fw-bold">Transform Your Interview Preparation</CardTitle>
                <CardText className="text-secondary" style={{textAlign:"justify"}}>Equip students with access to 15 types of AI-based interview practice, tailored to mimic real-world scenarios
                and as feedback to enhance their performance.</CardText>
              </CardBody>
            </Card>
          </Col>
          <Col md="4"  className="mb-3 align-middle" data-aos="fade-up">
           <Card className="shadow-sm text-center pb-1 custom-card" >
           <div style={{height:"5px",background:"#4FACFE"}}></div>
              <CardBody>
                <CardTitle tag="h5" className="fw-bold">Deliver World-Class Soft Skill Training</CardTitle>
                <CardText className=" text-secondary" style={{textAlign:"justify"}}>Provide 50 live soft skill courses facilitated by highly experienced and renowned professional coaches. These
courses cover a broad spectrum of critical skills, such as communication, time management, resume building,
personal branding, and leadership, ensuring holistic personal and professional growth.</CardText>
              </CardBody>
            </Card>
          </Col>
          <Col md="4"  className="mb-3 align-middle" data-aos="fade-up">
           <Card className="shadow-sm text-center pb-1 custom-card" >
           <div style={{height:"5px",background:"#4FACFE"}}></div>
              <CardBody>
                <CardTitle tag="h5" className=" fw-bold">Bridge the Skill Gap for Job Seekers</CardTitle>
                <CardText className=" text-secondary" style={{textAlign:"justify"}}>Create a robust platform that empowers job seekers with practical tools and training to boost their employability.
By integrating advanced AI technologies and expert guidance, the portal aims to address the evolving demands
of the competitive job market effectively.</CardText>
              </CardBody>
            </Card>
          </Col>
     
      </Row>


                <p className="my-2">
                 <strong>HKCL AI Application is not just an application; it’s a step toward creating a brighter and more
confident future for learners, enabling them to unlock their true potential and achieve their career aspirations.
</strong> 
                </p>
                
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section id="about-us" className="seminar-section">
        <Container className="py-1" data-aos="fade-up">
          <div>
            <h2 className="text-center mt-3">About Us</h2>
          </div>

          <Row>
            <Col
              md={4}
              xs={12}
              className="d-flex justify-content-center align-items-center"
              data-aos="fade-up"
            >
              <img src={logo1} width="140" alt="HKCL Logo" />
            </Col>
            <Col md={8} xs={12} data-aos="fade-up">
              <h4 className="text-muted">
               <span style={{color:"#f6821f"}}>H</span>aryana  <span style={{color:"#f6821f"}}>K</span>nowledge <span style={{color:"#f6821f"}}>C</span>orporation <span style={{color:"#f6821f"}}>L</span>imited
              </h4>
              <p className="text-justify" style={{textAlign:"justify"}}>
              Haryana Knowledge Corporation Limited (HKCL) is currently under the administration
of the Citizen Resource Information Department (CRID), Haryana. It was incorporated
under the Companies Act, 1956 dated September 10, 2013, issued by the Registrar of
Companies, National Capital Territory of Delhi, and Haryana to create a new paradigm
in education and development through universalization and integration of Information
Technology in teaching, learning and educational management processes and socio-economic transformative
processes in general. 

              </p>
              
            </Col>
          </Row>

          <Row>
            <Col xs={12} data-aos="fade-up">
              <p className="text-justify" style={{textAlign:"justify"}}>
              It is Promoted by the Government of Haryana along with Kurukshetra University (KU) Kurukshetra, Guru
Jambheshwar University of Science & Technology (GJUST) Hisar, Deen Bandhu Chhotu Ram University of Science
& Technology, (DCRUST) Murthal, Sonipat, Bhagat Phool Singh Mahila Vishvavidyalaya, (BPSMV), Khanpur Kalan,
Sonepat, HARTRON, Board of School Education – Haryana and Maharashtra Knowledge Corporation Ltd.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="seminardetails" >
        <Container className="py-4 " data-aos="fade-up">
          <div>
            <h2 className="text-center">About HKCL AI Application-Mentza</h2>
          </div>
      <Card className=" mt-3 p-3 shadow">

        <Row className="gx-1 ">
          <Col xs="6">
            <Button
              className={`w-100 py-2 fw-bold border-0 ${activePriceTab === "award" ? "active-tab" : "inactive-tab"}`}
              onClick={() => setActivePriceTab("award")}
            >
             Overview
            </Button>
          </Col>
          <Col xs="6">
            <Button
              className={`w-100 py-2 fw-bold border-0 ${activePriceTab === "technology" ? "active-tab" : "inactive-tab"}`}
              onClick={() => setActivePriceTab("technology")}
            >
          Why Choose Us
            </Button>
          </Col>
        </Row>

        {/* Content */}
        <CardBody className="text-center">
          {activePriceTab === "award" ? (
            <Row className="align-items-center justify-content-center" data-aos="fade-up">
             
              <Col md="11" className="text-start" >
              <p className="text-justify" style={{textAlign:"justify"}}>
            The HKCL AI Application is an innovative platform by HKCL designed to empower
students, job seekers, and learning centers with state-of-the-art tools for professional development. This application
offers AI-driven interview practice across multiple types of interviews, providing real-time feedback to enhance
performance. In addition, it offers live soft skill courses led by industry experts, covering essential skills like
communication, leadership, time management, resume building, and personal branding.
            </p>
            <p className="text-justify" style={{textAlign:"justify"}}>The platform is designed to bridge the skill gap, boost employability, and prepare users for the challenges of the
competitive job market. It helps students gain practical insights into real-world interview situations and enhances their
confidence, ensuring they are well-equipped for career success. 
</p>
              
              </Col>
            </Row>
          ) : (
            <Row className="align-items-center justify-content-center" data-aos="fade-up">
             
              <Col md="11" className="text-start" >
            <p>  HKCL AI Application-Mentza is crucial for students as it offers personalized AI-driven interview practice and live soft skill courses, helping them prepare effectively for different real-world job scenarios. It enhances their employability by bridging the skill gap, boosting confidence, and equipping them with the necessary tools to excel in interviews and professional settings, ultimately paving the way for their career success.</p>
              
              </Col>
            </Row>
          )}
        </CardBody>
      </Card>
      </Container>
    </section>


     


      <section id="pricing" className="">
        <Container className="py-1" data-aos="fade-up">
          <div>
            <h2 className="text-center my-3">Pricing</h2>
          </div>

          <Row className="justify-content-center">
            <img src={price} style={{width:"100%"}} />
        
      </Row>
        </Container>
      </section>


      <section id="faqsection" className="faq-section">
    <Container className="pt-4 pb-3" data-aos="fade-up">
      <h2 className="text-center">FAQs</h2>
      

      <Nav tabs>
        <NavItem>
          <NavLink
            className={activeTab === '1' ? 'active' : ''}
            onClick={() => toggleTab('1')}
          >
            For Students
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={activeTab === '2' ? 'active' : ''}
            onClick={() => toggleTab('2')}
          >
            For Authorized Learning Centres of HKCL
          </NavLink>
        </NavItem>
      </Nav>


      <TabContent activeTab={activeTab} style={{border:"1px solid #ededed",padding: "0 2%",borderRadius:"4px"}}>

        <TabPane tabId="1">
          <Accordion open={open} toggle={toggle} style={{borderRadius:"10px"}}>
            {faqDatastudent.map((faq) => (
              <AccordionItem
                key={faq.id}
                data-aos="fade-up"
                className="my-3"
                style={{ background: "",borderRadius:"8px" }}
              >
                <AccordionHeader
                  targetId={faq.id}
                  onClick={() => toggle(faq.id)}
                  style={{ background: "",borderRadius:"8px" }}
                >
                  {faq.id}. {faq.question}
                </AccordionHeader>
                <AccordionBody accordionId={faq.id}>
                  <div className="d-flex">
                    <FaChevronRight className="text-primary" />
                    &nbsp;&nbsp;&nbsp;
                    <span>{faq.answer}</span>
                  </div>
                </AccordionBody>
              </AccordionItem>
            ))}
          </Accordion>
        </TabPane>

      
        <TabPane tabId="2">
          <Accordion open={open} toggle={toggle} style={{borderRadius:"10px"}}>
            {faqDataalc.map((faq) => (
              <AccordionItem
                key={faq.id}
                data-aos="fade-up"
                className="my-3"
                style={{ background: "#e8e8e8",borderRadius:"8px" }}
              >
                <AccordionHeader
                  targetId={faq.id}
                  onClick={() => toggle(faq.id)}
                  style={{ background: "#e8e8e8",borderRadius:"8px" }}
                >
                  {faq.id}. {faq.question}
                </AccordionHeader>
                <AccordionBody accordionId={faq.id}>
                  <div className="d-flex">
                    <FaChevronRight className="text-primary" />
                    &nbsp;&nbsp;&nbsp;
                    <span>{faq.answer}</span>
                  </div>
                </AccordionBody>
              </AccordionItem>
            ))}
          </Accordion>
        </TabPane>
      </TabContent>
    </Container>
  </section>

      <div className="mb-5 text-center" data-aos="zoom-in">
        <button className="btn btn-success" onClick={() => navigate("/register")}>
          Enroll Now
        </button>
      </div>
    </>
  );
};

export default Home;
